import Modal, { ModalCloseButton } from './Modal';
import ModalContainer from './ModalContainer';
import { ModalHeader, ModalTitle, ModalBody, ModalFooter } from './ModalStyles';
import ModalDialog from './ModalDialog';
import ModalContent, { ModalContentBodyComponent, ModalContentFooterComponent, ModalContentHeaderComponent } from './ModalContent';

export { Modal, ModalContainer, ModalHeader, ModalBody, ModalFooter, ModalTitle, ModalCloseButton, ModalDialog, ModalContent,
    ModalContentBodyComponent, ModalContentFooterComponent, ModalContentHeaderComponent };

export type {LeftFooterAction, LeftFooterHyperlink, LeftFooterActionBase, LeftFooterButton, ModalHeaderIconButton} from './ModalTypes';
